export class RecurringPayment {
  public Id?: number;
  public FrequencyConfigurationId?: number;
  public FormId?: string;
  public FormDataId?: number;
  public OrderId?: string;
  public CustomerCardNumberId?: number;
  public StartDate?: Date;
  public EndDate?: Date;
  public IsRecurringPayment?: boolean;
  public IsAutoCharge?: boolean;
  public LocationId?: number;
}

export class RecurringPaymentConfig {
  FormId: string;
  Name: string;
  FrequencyRule: string;
  Id: number;
  PaymentStartImmediately: boolean = true;
  ReminderFrequencyType: string = 'Day';
  ReminderFrequencyValue: number = 1;
}
